import React from 'react';
import './DonationResult.css';

import { EmptyState, OfflineInstructions, PageTitle } from '../../../components';

import { FaHeart, FaRegHeart } from 'react-icons/fa';

import { useLocation } from 'react-router-dom';




const DonationResult = () => {

    const location = useLocation();
    const donationData = location.state?.donationData;

    const donationName = donationData?.donationTitle.replace(/_/g, " ");

    // If no donation data is found, display the empty state
    if (!donationData) {
        return (
            <>
                <PageTitle title={'Donation Confirmation'} page={'Donation Confirmation'} />
                <EmptyState
                    icon={FaRegHeart}
                    title="No Donations Yet"
                    message="You haven't made any donations yet. Join us in making a difference today."                    buttonLink="Donation"
                    buttonText="Donate Now"
                />
            </>
        );
    }

    return (
        <>
        
            <PageTitle title={'Donation Confirmation'} page={'Donation Confirmation'} />
                
            <section className="donation-result">

                {/* Donation Success Message */}
                <div className="donation-message donation-result-item">
                    <FaHeart className='icon' />
                    <span>Thank you for your generous donation, {donationData.name}!</span>
                </div>

                <div className="donation-receipt donation-result-item">
                    <div className="container">

                        <div className="shoplist-title">
                            <h3>Donation Receipt</h3>
                        </div>

                        <div className="box-container">

                            {/* Receipt Item 1: Donor */}
                            <div className="receipt-item">
                                <div className="box title">Donor</div>
                                <div className="box" id="donor">{donationData.name}</div>
                            </div>

                            {/* Receipt Item 2: Donation Amount */}
                            <div className="receipt-item">
                                <div className="box title">Donation Amount</div>
                                <div className="box" id="totalDonation">${donationData.amount}</div>
                            </div>

                            {/* Receipt Item 2: Donation Amount */}
                            <div className="receipt-item">
                                <div className="box title">Donation Type</div>
                                <div className="box" id="donationType">{donationData.donationType}</div>
                            </div>

                            {/* Receipt Item 3: Donation Cause */}
                            <div className="receipt-item">
                                <div className="box title">Donation Program</div>
                                <div className="box" id="donationCause">{donationName}</div>
                            </div>

                            {/* Receipt Item 4: Payment Method */}
                            <div className="receipt-item">
                                <div className="box title">Payment Method</div>
                                <div className="box" id="paymentMethod">{donationData.payment}</div>
                            </div>

                            {/* Receipt Item 5: Donation Date */}
                            <div className="receipt-item">
                                <div className="box title">Donation Date</div>
                                <div className="box" id="date">{donationData.date}</div>
                            </div>

                            {/* Receipt Item 7: Donor Email */}
                            <div className="receipt-item">
                                <div className="box title">Donor Email</div>
                                <div className="box" id="email">{donationData.email}</div>
                            </div>

                            {/* Receipt Item 8: Donor Phone Number */}
                            <div className="receipt-item">
                                <div className="box title">Donor Phone</div>
                                <div className="box" id="phoneNumber">{donationData.number}</div>
                            </div>

                            {/* Receipt Item 9: Donor Address */}
                            <div className="receipt-item">
                                <div className="box title">Donor Address</div>
                                <div className="box" id="address">{donationData.address}</div>
                            </div>

                        </div>

                    </div>
                </div>

                {/* Offline Payment Section - Only show if payment method is offline */}
                {donationData.payment === 'offline' && (
                    <div className="offline-payment donation-result-item">

                        <div className="shoplist-title">
                            <h3>Offline Donation Instructions</h3>
                        </div>

                        <div className='box-container'>
                            <OfflineInstructions />
                        </div>

                    </div>
                )}

            </section>

        </>

    );
};

export default DonationResult;